import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
  'view-settings.filter-panel.fieldless-filter-name': {
    id: 'view-settings.filter-panel.fieldless-filter-name',
    defaultMessage: 'Undefined',
    description:
      'The text displayed for a filter in the Filter view settings panel when the filter does not have a field associated with it'
  },
  'view-settings.sort-by-panel.alphabetical-ascending': {
    id: 'view-settings.sort-by-panel.alphabetical-ascending',
    defaultMessage: 'A → Z',
    description:
      'The label for the ascending sort direction for fields sorted alphabetically'
  },
  'view-settings.sort-by-panel.alphabetical-descending': {
    id: 'view-settings.sort-by-panel.alphabetical-descending',
    defaultMessage: 'Z → A',
    description:
      'The label for the descending sort direction for fields sorted alphabetically'
  },
  'view-settings.sort-by-panel.date-ascending': {
    id: 'view-settings.sort-by-panel.date-ascending',
    defaultMessage: 'Earliest → Latest',
    description: 'The label for the ascending sort direction for date-related fields'
  },
  'view-settings.sort-by-panel.date-descending': {
    id: 'view-settings.sort-by-panel.date-descending',
    defaultMessage: 'Latest → Earliest',
    description: 'The label for the descending sort direction for date-related fields'
  },
  'view-settings.sort-by-panel.more-actions': {
    id: 'view-settings.sort-by-panel.more-actions',
    defaultMessage: 'Show more actions',
    description:
      'The label for the icon button that shows more actions that can be taken on a "sort by" field"'
  },
  'view-settings.sort-by-panel.more-actions.delete': {
    id: 'view-settings.sort-by-panel.more-actions.delete',
    defaultMessage: 'Delete sort',
    description: 'Action menu item to delete this "sort by " field'
  },
  'view-settings.sort-by-panel.more-actions.move-down': {
    id: 'view-settings.sort-by-panel.more-actions.move-down',
    defaultMessage: 'Move sort down',
    description: 'Action menu item to move this "sort by " field down by 1 position'
  },
  'view-settings.sort-by-panel.more-actions.move-to-bottom': {
    id: 'view-settings.sort-by-panel.more-actions.move-to-bottom',
    defaultMessage: 'Move to bottom',
    description: 'Action menu item to move this "sort by " field position to the bottom'
  },
  'view-settings.sort-by-panel.more-actions.move-to-top': {
    id: 'view-settings.sort-by-panel.more-actions.move-to-top',
    defaultMessage: 'Move to top',
    description: 'Action menu item to move this "sort by " field position to the top'
  },
  'view-settings.sort-by-panel.more-actions.move-up': {
    id: 'view-settings.sort-by-panel.more-actions.move-up',
    defaultMessage: 'Move sort up',
    description: 'Action menu item to move this "sort by " field up by 1 position'
  },
  'view-settings.sort-by-panel.numeric-ascending': {
    id: 'view-settings.sort-by-panel.numeric-ascending',
    defaultMessage: '0 → 9',
    description:
      'The label for the ascending sort direction for fields sorted numerically'
  },
  'view-settings.sort-by-panel.numeric-descending': {
    id: 'view-settings.sort-by-panel.numeric-descending',
    defaultMessage: '9 → 0',
    description:
      'The label for the descending sort direction for fields sorted numerically'
  },
  'view-settings.sort-by-panel.checkbox-ascending': {
    id: 'view-settings.sort-by-panel.checkbox-ascending',
    defaultMessage: 'Unchecked → Checked',
    description: 'The label for the ascending sort direction for checkbox fields'
  },
  'view-settings.sort-by-panel.checkbox-descending': {
    id: 'view-settings.sort-by-panel.checkbox-descending',
    defaultMessage: 'Checked → Unchecked',
    description: 'The label for the descending sort direction for checkbox fields'
  },
  'view-settings.searchable-field-picker.no-results': {
    id: 'view-settings.searchable-field-picker.no-results',
    defaultMessage: 'No results',
    description: 'Message shown when search returns no matching fields'
  }
});
